import React from 'react';
import { useModal } from '@hooks';
import FeedbackModalContent from '../components/FeedbackModalContent';
import modalOptions from '../options';

export const useFeedbackModal = (type = 'campaign-paused') => {
    const { open, close } = useModal();
    const typeModalOptions = modalOptions[type];

    if (!typeModalOptions) {
        return { showFeedbackModal: () => {}, close: () => {} };
    }

    const showFeedbackModal = (onSuccess) => {
        open({
            title: <span data-e2e='feedback-modal_title'>{typeModalOptions?.title}</span>,
            content: <FeedbackModalContent close={close} type={type} onSuccess={onSuccess} />,
            settings: { maskClosable: false }
        });
    };

    return { showFeedbackModal, close };
};
